import React from 'react';

import {
  Field,
  HStack,
  Heading,
  VStack,
  useFormattedDate,
} from '@rtkwlf/fenrir-react';
import type { SecurityFocusState } from '@rtkwlf/track-public';

import { useSecurityJourneyTranslations } from '../../../../locales/use-security-journey-translations';
import { FocusStatusBadge } from '../../components/focus-status-badge';

type SecurityFocusHeaderProps = {
  focusName: string;
  focusState: SecurityFocusState;
  startedAt: Date | null;
  completedAt: Date | null;
};

export const SecurityFocusHeader: React.FC<SecurityFocusHeaderProps> = ({
  focusName,
  focusState,
  startedAt,
  completedAt,
}) => {
  const { t } = useSecurityJourneyTranslations();

  const format = 'prettyDate';

  const formattedStartDate = useFormattedDate(
    startedAt ? startedAt : new Date(),
    format,
  );

  const formattedCompleteDate = useFormattedDate(
    completedAt ? completedAt : new Date(),
    format,
  );

  return (
    <VStack>
      <HStack>
        <Heading level="1" styledAs="heading2">
          {focusName}
        </Heading>
        <FocusStatusBadge
          state={focusState}
          data-testid="security-focus-state-badge"
        />
      </HStack>
      <HStack paddingTop="small">
        <Field.Root>
          <Field.Label>{t('focusID.startDate')}</Field.Label>
          <Field.Content data-testid="security-focus-start-date">
            {startedAt ? formattedStartDate : t('focusID.notStarted')}
          </Field.Content>
        </Field.Root>
        {completedAt && (
          <Field.Root>
            <Field.Label>{t('focusID.endDate')}</Field.Label>
            <Field.Content data-testid="security-focus-end-date">
              {formattedCompleteDate}
            </Field.Content>
          </Field.Root>
        )}
      </HStack>
    </VStack>
  );
};
